import React from "react";
import ResizableTitle from "./ResizeableTitle";

const ExtraTableResize: React.FC<any> = ({ children, ...props }) => {
  // get last child
  const getLastChildProps = (props: any): any => {
    let data = {};
    if (!props.children) data = props;
    else data = getLastChildProps(props.children.props);
    return data;
  };

  let childProps = getLastChildProps(children.props);
  let { updateColumns, ...restProps } = childProps;

  // Get columns data
  let columns: any = [];
  if (props.columns) {
    columns = props.columns;
  } else {
    columns = childProps.columns;
  }

  const handleResize = (index: any) => (e: any, mouse: any) => {
    const nextColumns = [...columns];
    nextColumns[index] = {
      ...nextColumns[index],
      width: mouse.size.width,
    };
    // 更新
    if (updateColumns) updateColumns(nextColumns);
  };

  // modify column
  columns = columns.map((col: any, index: any) => {
    return {
      ...col,
      onHeaderCell: (column: any) => ({
        width: column.width,
        onResize: handleResize(index),
      }),
    };
  });

  //
  let components = {
    ...props.components,
    header: {
      cell: ResizableTitle,
    },
  };

  let propDatas = {
    components: components,
    columns: columns,
  };

  return (
    <div>
      {React.cloneElement(children || <></>, { ...restProps, ...propDatas })}
    </div>
  );
};
export { ExtraTableResize };
